import React from 'react';
import Button from './TagButton';

const ItemControls = (props) => {
    const { className, previous, close, next } = props;

    return (
        <div className={className}>
            <Button
                buttonType='button'
                className='btn__back'
                onClick={close}
                icon={true}
                title='Back'
                aria-label='Back'
            />
            {previous ?
                <Button
                    buttonType='button'
                    className='btn__previous'
                    icon={true}
                    title='Previous'
                    aria-label='Previous'
                    onClick={previous}
                />
                : ''
            }
            {next ?
                <Button
                    buttonType='button'
                    className='btn__next'
                    icon={true}
                    title='Next'
                    aria-label='Next'
                    onClick={next}
                />
                : ''
            }
        </div>
    )
}

export default ItemControls;